module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'global-map\'>\n    <div id=\'dashboard-placeholder\'></div>\n    <div id=\'map-search\'></div>\n</div>\n';

}
return __p
}